import React from 'react';
import PropTypes from 'prop-types';
import { PopoverContainer } from './Popover.style';
import NavigationHistory from '../../libs/NavigationHistory';

/* Animations */
const AnimationContainer = {
  enter: {
    y: '0%',
    transition: { type: 'tween', duration: 0.4, ease: [0, 0, 0, 1] }
  },
  exit: {
    y: '100%',
    transition: { duration: 0.4 },
    type: 'tween'
  }
};

const NoAnimationVariants = {
  enter: {
    opacity: 1
  },
  exit: {
    opacity: 1
  }
};

const Popover = (props) => {
  const { location, renderContent } = props;
  return (
    <PopoverContainer
      id="popoverPage"
      key={`popover${location.pathname}`}
      initial={Popover.isExitAnimation(props) ? 'enter' : 'exit'}
      variants={Popover.shouldAnimate(props) ? AnimationContainer : NoAnimationVariants}
      exit="exit"
      animate="enter"
      data-test-page-wrapper
    >
      {renderContent()}
    </PopoverContainer>
  );
};

Popover.shouldAnimate = (props) => {
  const { previousURL } = props.history;
  const isExit = previousURL ? props.navigationHistory.isPopoverURL(previousURL) : false;
  return previousURL || isExit;
};

Popover.isExitAnimation = (props) => {
  const { previousURL } = props.history;
  if (!previousURL || props.navigationHistory.isSameAsPreviousURL(props.location))
    return false;
  return previousURL ? props.navigationHistory.isPopoverURL(previousURL) : false;
};

Popover.propTypes = {
  renderContent: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  history: PropTypes.shape({
    previousURL: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  }).isRequired,
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired
};

export default Popover;
